import { type CheckoutTheme } from '@getjust/leaf';
import { useQuery } from '@tanstack/react-query';

import type { CheckoutV1 } from '@getjust/api-schema';
import type { PublicShop } from '@getjust/gateway';

import { useROFormMessageAtom } from '$hooks/state';
import { gateway } from '$src/http';

export type withConfig = {
  userInputMandatory?: boolean;
};

export type WithSettings = {
  upsell?: {
    intent?: 'related' | 'complementary';
    active?: boolean;
  };
  settings: {
    pickup: {
      activated: true;
      provider: {
        type: 'bigblue';
        apiToken: string;
      };
    };
    gdprMarketing?: {
      emailConsent: boolean;
      smsConsent: boolean;
    };
    gdprAccount?: {
      createAccount: boolean;
    };
    checkoutTheme?: CheckoutTheme;
    brandStyles?: CheckoutV1.BrandStyles;
  };
};

export const SHOP_QUERY_KEY = 'QUERY/SHOP';

export type Shop = PublicShop & WithSettings & withConfig;

export function useShop(shopId?: string) {
  const message = useROFormMessageAtom();

  const _shopId = shopId ?? message?.shopId;

  return useQuery({
    queryKey: [SHOP_QUERY_KEY],
    queryFn: async () => (await gateway.get<Shop>(`/api/${_shopId}`)).data,
    select: (response) => response,
    enabled: Boolean(_shopId),
  });
}
